/**
 * The space each identity lands on. The single redirect rule shared by the
 * login page and the space guards (RUI-13): before, the dialer redirected a
 * super admin by itself and showed "Session requise" or sent to /Login
 * depending on how /auth/me failed.
 */
export type Space = 'admin' | 'portal' | 'dialer';

export interface Identity {
  isSuperAdmin: boolean;
  role: string | null | undefined;
}

export function spaceForRole({ isSuperAdmin, role }: Identity): Space {
  if (isSuperAdmin) return 'admin';
  if (role === 'viewer') return 'portal';
  return 'dialer';
}

const HOME: Record<Space, string> = {
  admin: '/AdminOrganisations',
  portal: '/ClientDashboard',
  dialer: '/ParallelDialer/home',
};

export function homeForRole(identity: Identity): string {
  return HOME[spaceForRole(identity)];
}
